
import { Vue, Component, Prop } from "vue-property-decorator";
import {
  ExamAllList,
  ExamAllSearch,
  ExamSmallItem
} from "@/lib/model/exambuilder/exam-component/exam-list";

@Component({})
export default class CandidateSelect extends Vue {
  @Prop({ type: String, default: "请输入面试名称或备注进行搜索" })
  placeholder?: string;
  @Prop({ type: String, default: "全部面试" })
  activeName!: string;

  mounted() {
    document.addEventListener("click", (e: any) => {
      if (e.target && !this.$el.contains(e.target)) {
        this.showOptions = false;
      }
    });

    this.optionsInit();
  }

  // 初始化选项
  showOptions = false;
  searchValue = "";
  page = 1;
  optionsList: ExamSmallItem[] = [];

  optionsInit() {
    this.page = 1;
    this.getOptions().then((res: any) => {
      this.optionsList = res;
    });
  }

  async getOptions() {
    const params = new ExamAllSearch().assign({
      nameOrRemark: this.searchValue,
      PageSize: 20,
      page: this.page
    });

    const res = await ExamAllList.getList(params);

    return res.list;
  }

  searchValueChange(value: any) {
    this.page = 1;
    this.getOptions().then(res => {
      this.optionsList = res;
    });
    this.$emit("searchValueChange", value);
  }

  clearData() {
    this.page = 1;
  }

  extendOptions() {
    this.showOptions = !this.showOptions;
  }

  load() {
    this.page += 1;
    this.getOptions().then(res => {
      this.optionsList = this.optionsList.concat(res);
    });
  }

  activeItem = { name: "全部面试", examId: "" };

  optionsClick(item: any) {
    this.activeItem = item;
    this.$emit("change", this.activeItem);
    this.searchValue = "";
    this.optionsInit();
    this.showOptions = false;
  }
}
